import { EmailForm } from "components/foundation/EmailForm";
import { ProgrammaticLogo } from "components/library/Logos";
import { useBreakpoints } from "hooks/useBreakpoints";

export const FoundationHero = () => {
  const { isMediumWidth } = useBreakpoints();
  return (
    <div className="container-lg grid-12 mx-auto text-center  selection:border selection:bg-blue-200">
      <div className="col-span-full text-center">
        <h1 className="mx-auto mt-40 max-w-3xl font-display text-[44px] leading-[48px] md:text-[72px] md:leading-[88px]">
          Make{" "}
          <span className="rounded-lg bg-blue-200 px-6 pt-4  text-gray-900">
            GPT-3
          </span>{" "}
          faster,
          <span>
            <br />
          </span>{" "}
          cheaper, more effective
        </h1>
        <p className="mx-auto mt-24 mb-40 max-w-md text-14-20 leading-[22px] text-gray-700 md:max-w-xl md:text-20-32 ">
          Find <span className="hidden sm:inline-block">the</span> prompts users
          love and fine-tune{" "}
          <span className="hidden sm:inline-block">custom</span> models for
          <br />
          <span className="font-bold"> higher performance at lower cost</span>
        </p>
        <div className="mx-auto max-w-md md:max-w-lg">
          <EmailForm />
        </div>
      </div>
    </div>
  );
};
